<ng-container [ngTemplateOutlet]="map[key] ?? default" [ngTemplateOutletContext]="context"></ng-container>
